<template>
  <v-main
    :class="[
      !semMenuLateral && $vuetify.breakpoint.mdAndUp ? 'menu-lateral-desktop' : '',
      rodape && $vuetify.breakpoint.mdAndUp ? 'interna-desktop' : '',
      rodape && $vuetify.breakpoint.smAndDown ? 'interna-mobile' : '',
    ]"
    class="grey lighten-3 pt-12"
  >
    <v-container
      class="mx-auto pt-0"
      :style="`max-width:${ maxwidthContainer };`"
    >
      <slot />
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'InternaMain',

  props: {
    maxwidthContainer: {
      type: String,
      default: '1200px',
    },

    rodape: {
      type: Boolean,
      default: false,
    },

    semMenuLateral: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.interna-mobile { padding-bottom: 100px !important; }
.interna-desktop { padding-bottom: 150px !important; }
.menu-lateral-desktop { padding-left: 56px !important; }
</style>
